import { Alert, Col, Divider, Row, Table, Modal } from 'antd';
import { Button, PageHeader } from 'components';
import { useTranslation } from 'react-i18next';
import styles from '../main/style.module.scss';
import UIHelper from 'helpers/UIHelper';
import useInvoices from '../useInvoices';
import Filters from 'components/filters';
import { ExcelIcon } from '../../../../../icons';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ActionModal from '../../../../../components/actionModal';

const BlankInvoices = () => {
  const {
    data,
    columns,
    loading,
    onChangeTableFilter,
    filters,
    onExportTo,
    handleDownloadExcel,
    modalVisible,
    handleModalOk,
    handleModalCancel,
    setComment,
    currentAction,
  } = useInvoices(true, true);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleOnRow = useCallback(
    (record) => ({
      onClick: () => {
        navigate(`${record.id}`);
      },
    }),
    [navigate],
  );

  const [showModal, setShowModal] = useState(false);

  const toggleExportModal = useCallback((e) => {
    e.stopPropagation();
    setShowModal((s) => !s);
  }, []);

  const clickOk = async () => {
    try {
      await onExportTo();
      setShowModal(false);
    } catch (e) {}
  };

  const exportModal = showModal ? (
    <ActionModal
      loading={loading}
      title={t('Export ot Nego')}
      description={t('Sei sicuro che vuoi esportare dati?')}
      yesBtnText={t('Si')}
      noBtnText={t('No')}
      onClickOk={clickOk}
      onCancel={toggleExportModal}
      type={'info'}
    />
  ) : null;
  return (
    <>
      <PageHeader title={t('Fatturato da approvare').toUpperCase()}>
        <Row gutter={16}>
          <Col>
            <Button
              big
              type={'green'}
              iconMargin
              icon={<ExcelIcon fill={'#fff'} />}
              onClick={handleDownloadExcel}
            >
              {t('Export')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.container}>
        <Alert
          message={t(
            '* Necessario selezionare filtro outlet village per visualizzare i fatturati correttamente',
          )}
          type='warning'
        />
        <br />
        <Filters filters={filters} sortFilters />
        <Divider />
        <Table
          columns={UIHelper.assignTire(columns)}
          dataSource={data.invoices}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
          scroll={{ x: 2000 }}
          onRow={handleOnRow}
        />
      </div>
      {modalVisible && (
        <Modal
          title={t(
            currentAction === 'approve' ? 'Approva Fattura' : 'Rifiuta Fattura',
          )}
          visible={modalVisible}
          onOk={handleModalOk}
          onCancel={handleModalCancel}
          bodyStyle={{ padding: '24px' }}
          footer={null}
        >
          <textarea
            placeholder={t('Aggiungi un commento')}
            onChange={(e) => setComment(e.target.value)}
            style={{ width: '100%', height: '100px', padding: '14px' }}
          />
          <Row gutter={14} justify='end' style={{ marginTop: '16px' }}>
            <Col>
              <Button onClick={handleModalOk} style={{ width: '100px' }}>
                {t('Sì')}
              </Button>
            </Col>
            <Col>
              <Button
                onClick={handleModalCancel}
                style={{ width: '100px' }}
                type={'primary-white'}
              >
                {t('No')}
              </Button>
            </Col>
          </Row>
        </Modal>
      )}
      {exportModal}
    </>
  );
};

export default BlankInvoices;
